// Shared by the audit list and detail screens (ENB-577).

// dateFields are the record's own dates an admin can filter by (the keys match the API's whitelist);
// the first one is the default. They are what people remember (when the order was received), not
// when the change was audited.
export const auditTypes = {
  orders: {
    title: "Orders Audit",
    descriptionHeader: "Client",
    showStatus: true,
    dateFields: [
      { value: "date_received", label: "Date Received" },
      { value: "date_created", label: "Date Created" },
      { value: "date_reported", label: "Date Reported" },
      { value: "date_completed", label: "Date Completed" },
      { value: "report_due_date", label: "Due Date" },
      { value: "date_invoiced", label: "Date Invoiced" },
    ],
  },
  samples: {
    title: "Samples Audit",
    descriptionHeader: "Sample Identity",
    showStatus: false,
    dateFields: [
      { value: "date_received", label: "Date Received" },
      { value: "date_collected", label: "Date Collected" },
    ],
  },
  results: {
    title: "Results Audit",
    descriptionHeader: "Result",
    showStatus: true,
    dateFields: [
      { value: "date_of_analysis", label: "Date of Analysis" },
      { value: "date_entered", label: "Date Entered" },
    ],
  },
};

// Audit rows written before AuditDate was added (2026-10-22) have no write time.
export const formatAuditDate = (value) => {
  if (!value) return "";
  return new Date(value).toLocaleString();
};

// The record's own dates carry no useful time of day.
export const formatDay = (value) => {
  if (!value) return "";
  return new Date(value).toLocaleDateString();
};

// "client_name" -> "client name"
export const formatFieldName = (field) => (field || "").replace(/_/g, " ");

// ky throws on 4xx/5xx; the API puts the reason (for example "Only admins can view the audit log.")
// in the standard payload.
export const getAuditErrorMessage = async (err) => {
  try {
    const body = await err.response.json();
    if (body && body.message) return body.message;
  } catch (e) {
    // fall through to the generic message
  }
  return err?.message || String(err);
};

// The detail screen opens in a new tab and reads its keys from the query string.
export const buildDetailUrl = (type, item) => {
  const query = new URLSearchParams({ orderNumber: item.orderNumber });
  if (item.sampleNumber !== null && item.sampleNumber !== undefined) query.set("sampleNumber", item.sampleNumber);
  if (item.testCode) query.set("testCode", item.testCode);
  if (item.parameter) query.set("parameter", item.parameter);
  return `/vlp/settings-audit-log-detail/${type}?${query.toString()}`;
};
